import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const TransportationTypeIdSelectorAtom = atom<string | null>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);

  return bookingWizardData?.type === "GolfBooking" &&
    bookingWizardData.transportationTypeId
    ? bookingWizardData.transportationTypeId
    : null;
});
